import React from "react";
import { cn } from "../utils";

import { Text } from '@virkesborsen/ui-component-library';

// import type { CustomTooltipProps } from '../Charts.types';

import {
  toolTipDatasetWrapper,
  toolTipItem,
  toolTipItemColor,
  toolTipWrapper,
} from '../Chart.styles';

export const CustomTooltip = ({
  active,
  payload,
  label,
  customTooltipLabel,
  className,
}) => {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div className={cn(toolTipWrapper(), className)}>
      <Text variant="text-xs/leading-none/normal">
        {customTooltipLabel?.title} {label} {customTooltipLabel?.unit}
      </Text>
      {/* List of datasets */}
      <div className={cn(toolTipDatasetWrapper(), className)}>
        {payload.map((entry, index) => {
          const unit = entry?.payload?.unit || '';
          return (
            <div key={`tooltip-item-${index}`} className={cn(toolTipItem(), className)}>
              {/* Commented this out because we will need it in pricecomparison for multiple graphs in one chart to identify difference in data */}
              {/* {entry.color && (
                <div
                  className={cn(toolTipItemColor(), className)}
                  style={{ backgroundColor: entry.color }}
                />
              )} */}

              <Text variant="text-sm/leading-none/normal" className="text-neutral-500">
                {entry.value} {unit}
              </Text>
            </div>
          );
        })}
      </div>
    </div>
  );
};
